import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose, IoGameControllerOutline, IoMenu, IoVideocam } from "react-icons/io5";
import { MdOutlinePolicy, MdOutlineDashboard, MdDashboard, MdPolicy, MdGroup, MdReadMore, MdNotificationAdd, MdOutlineSlowMotionVideo } from "react-icons/md";
import { MdOutlineGroup } from "react-icons/md";
import { BsBadgeAd, BsBadgeAdFill } from "react-icons/bs";
import { FaBook, FaCoins, FaTrophy } from "react-icons/fa";
import { SiQuizlet } from "react-icons/si";
import { GrContact } from "react-icons/gr";
import { BiMoneyWithdraw } from 'react-icons/bi';
import { GoDot } from "react-icons/go";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";

const Navbar1 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [onSelect, setOnSelect] = useState([]);
    const location = useLocation();
    const [expandedMenus, setExpandedMenus] = useState({});

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const pathArray = location.pathname.split('/');  // Split the pathname into segments
        // If the path is empty (i.e., the user is on the homepage), default to 'dashboard'
        setOnSelect(pathArray[1] === '' ? ['dashboard'] : pathArray);

        // Auto-expand menu if a submenu item is selected
        navItems.forEach(item => {
            if (item.hasSubmenu && item.submenu.some(subItem => location.pathname === subItem.path)) {
                setExpandedMenus(prev => ({
                    ...prev,
                    [item.id]: true
                }));
            }
        });
    }, [location.pathname]);  // Re-run when pathname changes

    const handleMouseEnter = () => {
        if (!isMobile) setIsOpen(true);
    };

    const handleMouseLeave = () => {
        if (!isMobile) setIsOpen(false);
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleMobileClick = () => {
        if (isMobile) {
            setIsOpen(false);
        }
    };

    const toggleSubmenu = (id) => {
        setExpandedMenus(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const getSelectedIcon = (item) => {
        return onSelect.includes(item) ? true : false
    };

    const isSubmenuItemSelected = (parentId, path) => {
        return location.pathname === path;
    };

    // Function to check if any submenu item of a parent is selected
    const isAnySubmenuItemSelected = (item) => {
        if (!item.hasSubmenu) return false;
        return item.submenu.some(subItem => location.pathname === subItem.path);
    };

    const navItems = [
        {
            id: 'dashboard',
            path: '/',
            label: 'Dashboard',
            icon: (selected) => selected ? <MdDashboard size={20} /> : <MdOutlineDashboard size={20} />,
        },
        {
            id: 'user',
            path: '/manage/user/all/data',
            label: 'User Manager',
            icon: (selected) => selected ? <MdGroup size={20} /> : <MdOutlineGroup size={20} />,
        },
        {
            id: 'withdraw',
            path: '/manage/withdraw/request',
            label: 'Redeem Manager',
            icon: (selected) => selected ? <BiMoneyWithdraw size={20} /> : <BiMoneyWithdraw size={20} />,
        },
        {
            id: 'ads',
            path: '/manage/ads/nativeAds/add',
            label: 'Ads Manager',
            icon: (selected) => selected ? <BsBadgeAdFill size={20} /> : <BsBadgeAd size={20} />,
        },
        {
            id: 'question',
            path: '/manage/question',
            label: 'Questions Book',
            icon: () => <FaBook size={18} />,
        },
        {
            id: 'quiz',
            path: '/manage/quiz/show',
            label: 'Quiz',
            icon: () => <SiQuizlet size={18} />,
        },
        {
            id: 'leaderboards',
            path: '/main/leaderboards',
            label: 'Leaderboard',
            icon: () => <FaTrophy size={18} />,
        },
        {
            id: 'contact',
            path: '/manage/contact/chat',
            label: 'Help & Support',
            icon: () => <GrContact size={18} />,
        },
        {
            id: 'game',
            path: '/manage/game/all',
            label: 'Game',
            icon: () => <IoGameControllerOutline size={20} />,
        },
        {
            id: 'reels',
            path: '/manage/reels',
            label: 'Reels',
            icon: () => <MdOutlineSlowMotionVideo size={20} />,
        }
        ,
        {
            id: 'coin',
            path: '/coin/notification',
            label: 'Notification',
            icon: () => <MdNotificationAdd size={20} />,
        },
        {
            id: 'other',
            label: 'Other',
            icon: () => <MdReadMore size={18} />,
            hasSubmenu: true,
            submenu: [
                {
                    id: 'policy',
                    path: '/policy',
                    label: 'Policy',
                    icon: () => <MdOutlinePolicy size={16} />
                },
                {
                    id: 'guide-video',
                    path: '/guide/video',
                    label: 'Guide Video',
                    icon: () => <IoVideocam size={16} />
                },
                {
                    id: 'win-bar',
                    path: '/manage/winbar',
                    label: 'Win Bar',
                    icon: () => <GoDot size={16} />
                }
            ]
        }
    ];

    const getColorClasses = (selected) => {
        // Simplified to use bg-main-blue for selected state and bg-main-th for hover
        return selected ? 'bg-main-blue text-white' : 'hover:bg-main-th text-gray-600 hover:text-main-blue';
    };

    return (
        <>
            {/* Mobile menu toggle button */}
            {isMobile && (
                <button
                    className="fixed top-4 left-4 z-50 bg-main-blue text-white p-2.5 rounded-lg shadow-lg hover:bg-main-blue/90 transition-colors duration-200"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                >
                    {isOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
                </button>
            )}

            <div
                className={`fixed top-0 z-40 left-0 h-screen transition-all duration-200 ease-out ${isMobile
                    ? (isOpen ? 'w-64 translate-x-0' : 'w-0 -translate-x-full')
                    : (isOpen ? 'w-56' : 'w-16')
                    } ${isMobile ? 'mt-16' : 'mt-20'}`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <nav className="bg-white h-full shadow-xl border-r border-gray-200 flex flex-col overflow-hidden">
                    {/* Navigation Items */}
                    <div className="flex-1 py-3 px-3 overflow-y-auto">
                        <ul className="space-y-1">
                            {navItems.map((item) => {
                                const selected = getSelectedIcon(item.id);
                                const isExpanded = expandedMenus[item.id];

                                return (
                                    <li key={item.id}>
                                        {item.hasSubmenu ? (
                                            <div className="space-y-1">
                                                <button
                                                    onClick={() => toggleSubmenu(item.id)}
                                                    className={`
                                                        w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-all duration-150
                                                        ${selected || isAnySubmenuItemSelected(item) ? 'bg-main-blue text-white shadow-md' : 'hover:bg-main-th text-gray-600 hover:text-main-blue'}
                                                        ${!isOpen && !isMobile ? 'justify-center' : ''}
                                                    `}
                                                >
                                                    <div className="flex items-center">
                                                        <div className="flex items-center justify-center w-5 h-5">
                                                            {item.icon(selected)}
                                                        </div>
                                                        {(isOpen || (isMobile && isOpen)) && (
                                                            <span className="ml-3 font-medium whitespace-nowrap">
                                                                {item.label}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {(isOpen || (isMobile && isOpen)) && (
                                                        <div>
                                                            {isExpanded ? <IoIosArrowDown size={16} /> : <IoIosArrowForward size={16} />}
                                                        </div>
                                                    )}
                                                </button>

                                                {/* Submenu items */}
                                                {(isOpen || (isMobile && isOpen)) && isExpanded && (
                                                    <ul className="pl-8 space-y-1 mt-1">
                                                        {item.submenu.map((subItem) => {
                                                            const subItemSelected = isSubmenuItemSelected(item.id, subItem.path);
                                                            return (
                                                                <li key={subItem.id}>
                                                                    <Link
                                                                        to={subItem.path}
                                                                        onClick={handleMobileClick}
                                                                        className={`
                                                                            flex items-center px-3 py-2 rounded-lg transition-all duration-150 text-sm
                                                                            ${subItemSelected ? 'bg-main-blue/20 text-main-blue font-medium' : 'text-gray-600 hover:bg-main-th hover:text-main-blue'}
                                                                        `}
                                                                    >
                                                                        {subItem.icon && (
                                                                            <div className="flex items-center justify-center w-5 h-5 mr-2">
                                                                                {subItem.icon(subItemSelected)}
                                                                            </div>
                                                                        )}
                                                                        <span>{subItem.label}</span>
                                                                    </Link>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                )}
                                            </div>
                                        ) : (
                                            <Link
                                                to={item.path}
                                                onClick={handleMobileClick}
                                                className={`
                                                    flex items-center px-3 py-2.5 rounded-lg transition-all duration-150
                                                    ${getColorClasses(selected)}
                                                    ${selected ? 'shadow-md' : ''}
                                                    ${!isOpen && !isMobile ? 'justify-center' : ''}
                                                `}
                                            >
                                                <div className="flex items-center justify-center w-5 h-5">
                                                    {item.icon(selected)}
                                                </div>
                                                {(isOpen || (isMobile && isOpen)) && (
                                                    <span className="ml-3 font-medium whitespace-nowrap">
                                                        {item.label}
                                                    </span>
                                                )}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </nav>
            </div>

            {/* Mobile overlay */}
            {isMobile && isOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-30 transition-opacity duration-200"
                    onClick={toggleMenu}
                >

                </div>
            )}
        </>
    );
};

export default Navbar1;